<template>
    <div v-if="fetchClassroom">
      <b-modal 
			:active.sync="modalAssign"
			has-modal-card
			trap-focus
			:destroy-on-hide="true"
			aria-role="dialog"
			aria-modal>
        <assign-classroom :id="id" @over="modalAssign=false" />
      </b-modal>
      <section class="hero is-flex main" >
        <div class="bg-icon star">
          <img src="@/assets/images/stars.png" alt="" />
        </div>
        <div style="display:flex;width:100%">
          <div style="flex-grow:1">
            <h3 class="title ">{{fetchClassroom.name}}</h3>
          </div>
          <div class="buttons is-right" style="display:flex;">
            <b-button class="button is-primary" @click="modalAssign = true" >Assign</b-button>
            <b-button class="button is-primary" @click="$router.push({ name: 'view-categories', params: { grade_subject_id: fetchClassroom.grade_subject }, query: { classroom_id: id} })">View Categories</b-button>
          </div>
        </div>
        <p>{{fetchClassroom.remarks}}</p>
        <div class="card-container">
          <div class="left-card">
            <div class="mb-4 has-text-centered" style="width:100%">
                <span class="is-size-3"><b>Teachers</b></span>
            </div>
            <b-table :hoverable="true" class="table is-fullwidth" :data='fetchClassroom.teachers'>
                <b-table-column label="Name" v-slot="props" sortable>
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column label="Email" v-slot="props" sortable>
                    {{ props.row.email }}
                </b-table-column>
                <b-table-column label="Action" class="is-actions-cell" v-slot="props">
                  <div class="buttons is-right" style="display:block">
                    <b-button class="button is-small is-danger" type="button"  @click="delete(props.row._id)">
                      <b-icon
                        icon="delete"
                        size="is-small">
                      </b-icon>
                    </b-button>
                  </div>
                </b-table-column>
              </b-table>
          </div>
          <div class="right-card">
            <div class="mb-4 has-text-centered" style="width:100%">
                <span class="is-size-3"><b>Students</b></span>
            </div>
            <b-table class="table is-fullwidth" :hoverable="true" :data='fetchClassroomStudents'>
                <b-table-column label="Name" v-slot="props" sortable>
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column label="Email" v-slot="props" sortable>
                    {{ props.row.email }}
                </b-table-column>
                <b-table-column label="Skills Practiced" v-slot="props" sortable>
                    {{ props.row.analytics.skills_practiced }}
                </b-table-column>
                <b-table-column label="Questions Solved" v-slot="props" sortable>
                    {{ props.row.analytics.questions_attempted }}
                </b-table-column>
                <b-table-column label="Time Taken" v-slot="props" sortable>
                  {{ props.row.analytics.time_taken }} mins
                </b-table-column>
                <b-table-column label="Last Practiced" sortable>
                  22nd January, 2023
                </b-table-column>
                <b-table-column label="Action" class="is-actions-cell" v-slot="props">
                  <div class="buttons is-right" style="display:block">
                    <b-button class="button is-small is-danger" type="button" @click="$router.push(`/kid/${props.row.kid_id}/analytics?grade_subject=${fetchClassroom.grade_subject}`)">
                      <b-icon
                        icon="chart-bar"
                        size="is-small">
                      </b-icon>
                    </b-button>
                    <b-button class="button is-small is-danger" type="button"  @click="delete(props.row._id)">
                      <b-icon
                        icon="delete"
                        size="is-small">
                      </b-icon>
                    </b-button>
                  </div>
                </b-table-column>
            </b-table>
          </div>
        </div>
      </section>
    </div>
  </template>
    <script>
    import { mapGetters, mapActions } from 'vuex';
    import AssignClassroom from "@/components/School/AssignClassroom"

    export default {
      name: "ClassroomDetails",
      components: {
        AssignClassroom
      },
      props: {
        id:{
            type : String,
            required : true
        },
      },
      data() {
        return {
          modalAssign:false,
        };
      },
      computed:{
        ...mapGetters(['fetchClassroom', 'getTeacherToken', 'fetchClassroomStudents']),
      },
      methods: {
        ...mapActions(['loadClassroom', 'loadClassroomStudents']),
      },
      mounted: function () {
        // Adding 1000 milliseconds delay because we cannot catch child component mounted hook
        this.$nextTick(() => {
          setTimeout(function () {
            document.getElementsByTagName("input")[0]?.focus();
          }, 1000);
        });
      },
      watch: {
        fetchCurrentQuestionIndex: function () {
          //Checking if this question is already answered
          this.initializeCurrentAnswer();
    
          setTimeout(function () {
            document.getElementsByTagName("input")[0]?.focus();
          }, 1000);
        },
      },
      async created() {
        this.loadClassroom({token: this.getTeacherToken, id: this.id})
        this.loadClassroomStudents({ token : this.getTeacherToken, id: this.id, analytics : true })
      },
    };
    </script>
      <style scoped>
    @import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap");
    .flex {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .container {
      position: relative;
    }
    
    .bg-img {
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    .bg-img div {
      display: flex;
      position: absolute;
      width: auto;
    }
    
    .title {
      font-size: 3vw;
      margin: 0 !important;
    }
    
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
    
    .button {
      flex-direction: row;
      padding: 1vw 1.25vw;
      width: 100%;
      background: #8919e7;
      border-radius: 1vw;
      color: #fff;
      gap: 1vw;
      cursor: pointer;
      position: relative;
      text-transform: capitalize;
    }
    .button.outline {
      border: 0.063rem solid #8919e7;
      background: #fff;
      color: #000;
    }
    .link {
      cursor: pointer;
    }
    .main {
      align-items: center;
      margin: 0vw 0vw;
      position: relative;
      gap: 2.4vw;
    }
    /* responsive page*/
    /* tablet */
    @media screen and (max-width: 1023px) {
      .title {
        font-size: 3.5vw !important;
      }
    }
    
    /* Mobiles */
    @media screen and (max-width: 767px) {
      .title {
        font-size: 4vw !important;
      }
    }
    
    @media screen and (max-width: 467px) {
      .title {
        font-size: 5vw !important;
      }
    }
    .bg-icon {
      position: absolute;
    }
    
    .star {
      left: 77vw;
      top: -4vw;
      max-width: 5vw;
    }
    
    .main {
      align-items: center;
      margin: 6.76vw 4.4vw;
      position: relative;
      gap: 2.4vw;
    }
    .main .card-container {
      display: flex;
      justify-content: center;
      gap: 2.2vw;
      width: 100%;
    }
    .main .card-container .left-card,
    .main .card-container .right-card {
      display: flex;
      flex-direction: column;
      /* flex: 1; */
      
      justify-content: center;
      align-items: flex-start;
      padding: 3.6vw 2vw;
      border-radius: 1.8vw;
    }
    .main .card-container .left-card {
      background: rgba(137, 25, 231, 0.1);
      justify-content: flex-start;
    }
    .main .card-container .left-card .button ,
    .main .card-container .right-card .button {
      
      max-width: -webkit-fit-content;
      max-width: -moz-fit-content;
      max-width: fit-content;
      padding: 1.2vw 5vw;
      border-radius: 1.1vw;
      font-size: 1.2vw;
    }
    .main .card-container .right-card {
      background: rgba(49, 200, 255, 0.0784313725);
      justify-content: flex-start;
      flex: 1;
    }
    
    @media screen and (max-width: 767px) {
      .main .card-container {
        flex-direction: column;
      }
      .main .card-container .right-card .svg {
        right: 5% !important;
      }
      .title {
        font-size: 3.5vw !important;
      }
    }
    .drag-sortable {
      float: left;
    }
    
    hr {
      margin: 0.5rem 0 !important;
    }
    </style>